import { createReducer } from "@reduxjs/toolkit";
import { IWorkflowTemplateState } from "./types";
import * as actions from "./actions";
import { StoreState } from "../storeState";
import { STORAGE_RESET } from "../storeReset";

const initialState = {
  data: null,
  state: StoreState.None,
} as IWorkflowTemplateState;

export const workflowTemplateReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(actions.workflowTemplateFetchRequest, (state) => ({
      ...state,
      state: StoreState.Loading,
    }))
    .addCase(actions.workflowTemplateFetchSuccess, (state, action) => ({
      ...state,
      state: StoreState.Loaded,
      data: action.payload,
    }))
    .addCase(actions.workflowTemplateFetchError, (state) => ({
      ...state,
      state: StoreState.Error,
    }))
    .addCase(STORAGE_RESET, () => initialState)
);
